import React from "react";
import { useTranslation } from 'react-i18next'
import { motion } from "framer-motion";
import Counter from "../inc/Counter";
import { Link } from "react-router-dom";

const Gallerysection = ({gallerydata}) => {
  let top_imgs = gallerydata.img_tops;
  let bottom_imgs = gallerydata.img_bottoms;
  const { t, i18n } = useTranslation()
   
  return (
    <section className="number-gallery-section">
    <div className="gallery-top-part">
      
        <div className="top-part-wrapper d-flex">
          
        {top_imgs.map((img, index) => (
            <div key={img.id || index} className="tp-gallery-item">
                <img src={img} alt="" className="   "/>
            </div>
    ))}
        </div>
    </div>
    <div className="gallery-middle-part">
        <div className="middle-content">
        <Counter  to={gallerydata.text_middels.one} duration={6} />
            
            <p>{gallerydata.text_middels.two}</p>
            
            <motion.div className="gallery-item-inner"
  initial={{ opacity: 0, y: 50 }}
  whileInView={{ opacity: 1, y: 0 }}
  transition={{ duration: 0.5 }}
  viewport={{ once: true }}
>
                <img src={gallerydata.img_middels[0]} alt="" className="   "/>
                </motion.div>
        </div>
    </div>
    <div className="gallery-bottom-part">
        <div className="bottm-wrapper d-flex justify-content-between">
        {bottom_imgs.map((img, index) => (
            <motion.div key={img.id || index} className="tp-gallery-item"
  initial={{ opacity: 0, y: 100 }}
  whileInView={{ opacity: 1, y: 0 }}
  transition={{ duration: 0.8 }}
  viewport={{ once: true }}
>
                <img src={img} alt="" className="   "/>
            </motion.div>
        ))}
            
        </div>
    </div>
</section>
  );
};

export default Gallerysection;